export default __webpack_public_path__ + "static/media/Bottom Navigation.922aa706.svg";